import React from 'react';
import { Link } from 'react-router-dom';
import yobsti_logo from '../../public/img/logo.png';
import footerBgMobile from '../../public/svg/obst-bg.svg';
import { FaInstagram, FaFacebookF, FaWhatsapp } from 'react-icons/fa';
import { FACEBOOK_URL, INSTAGRAM_URL, WHATSAPP_CHAT_URL } from '@/data/contact';
import { track } from '@/helpers/analytics';

const Footer: React.FC = () => {

  return (
    <footer
      className="w-full py-12 border-t bg-secondaryLight bg-center"
      style={{ backgroundImage: `url(${footerBgMobile})` }}
    >
      <div className="mx-auto px-5 max-w-7xl">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left gap-8 md:gap-0">

          <div>
            <Link to="/" className="flex justify-center md:justify-start items-center">
              <img
                src={yobsti_logo}
                alt="Yobst Logo"
                loading="lazy"
                className="h-12"
              />
            </Link>
            <div className="mt-4 text-sm">
              © {new Date().getFullYear()} Yobsti Nahversorgung GmbH. All Rights Reserved.
            </div>
          </div>

          <div className="flex flex-col md:flex-row justify-center md:justify-center items-center gap-3 md:gap-8 text-md font-semibold">
            <Link to="/fuer-gemeinden" className="hover:text-primaryDark">
              Für Gemeinden
            </Link>
            <Link to="/impressum" className="hover:text-primaryDark">
              Impressum
            </Link>
            <Link to="/datenschutz" className="hover:text-primaryDark">
              Datenschutz
            </Link>
            <Link to="/kontakt" className="hover:text-primaryDark">
              Kontakt
            </Link>
          </div>

          <div className="flex justify-center md:justify-end gap-6 text-2xl text-primaryDark">
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => track('social-click', { network: 'instagram', location: 'footer' })}
              className="hover:text-lineGreen transition"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href={FACEBOOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => track('social-click', { network: 'facebook', location: 'footer' })}
              className="hover:text-lineGreen transition"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href={WHATSAPP_CHAT_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => track('whatsapp-click', { location: 'footer' })}
              className="hover:text-lineGreen transition"
              aria-label="WhatsApp"
            >
              <FaWhatsapp />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;